import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import axios from "axios";
import ProfileBanner from "../../../components/sections/ProfileBanner";
import FeedSection from "../../../components/sections/FeedSection";
import SchoolAnnouncementFeed from "../../../components/sections/SchoolAnnouncementFeed";
import BirthdayFeed from "../../../components/sections/BirthdayFeed";
import { serverUrl } from "../../../nestserver";
import { selectUser } from "../../../redux/slices/auth.slice";
import AdminProfile from "./form/AdminProfile";
import Announcement from "../../../components/sections/Announcement";

function MainProfile() {
  const user = useSelector(selectUser);
  const [activeTab, setActiveTab] = useState("school-post");

  async function getAnnouncement() {
    const data = await axios({
      method: "get",
      url: serverUrl + "/announcement",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return data.data;
  }

  const announcement = useQuery("announcement", getAnnouncement);

  return (
    <>
      <ProfileBanner
        userId={user?._id}
        roleData={user?.admin}
        patchUrl={serverUrl + "/admin/" + user?.admin?._id}
        EditFormComponent={AdminProfile}
      />

      <Announcement />
      <div className="py-10">
        <div className="bg-white w-full rounded-2xl bg-opacity-40 px-4 pb-4">
          <div className="flex items-center gap-8 p-4 py-6">
            <div
              onClick={() => setActiveTab("school-post")}
              className="text-2xl font-semibold cursor-pointer pb-1"
              style={{
                color: activeTab === "school-post" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "school-post"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              School Post
            </div>
            <div
              onClick={() => setActiveTab("class-update")}
              className="text-2xl font-semibold cursor-pointer pb-1"
              style={{
                color: activeTab === "class-update" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "class-update"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              Class Update
            </div>
            <div
              onClick={() => setActiveTab("birthday")}
              className="text-2xl font-semibold cursor-pointer pb-1"
              style={{
                color: activeTab === "birthday" ? "#E46E31" : "#9ca3af",
                borderBottom:
                  activeTab === "birthday"
                    ? "3px solid #E46E31"
                    : "3px solid transparent",
              }}
            >
              🎂 Birthday
            </div>
          </div>

          {activeTab === "school-post" ? (
            <div className="space-y-5 ">
              {announcement?.isSuccess &&
                announcement?.data
                  ?.slice()
                  ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                  ?.map((item, index) => {
                    return (
                      <FeedSection
                        enableDelete={true}
                        key={item?._id}
                        data={item}
                      />
                    );
                  })}
            </div>
          ) : activeTab === "class-update" ? (
            <SchoolAnnouncementFeed />
          ) : (
            <BirthdayFeed />
          )}
        </div>
      </div>
    </>
  );
}

export default MainProfile;
